import { render, staticRenderFns } from "./FormEstabelecimento.vue?vue&type=template&id=f0d033ca&"
import script from "./FormEstabelecimento.vue?vue&type=script&lang=js&"
export * from "./FormEstabelecimento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports